import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Options } from 'ng5-slider';
import { Router, ActivatedRoute } from '@angular/router'
import { DOCUMENT } from '@angular/common';
import { AppglobalService } from '../../services/appglobal.service';
import { SearchService } from '../../services/search.service'
import { Search } from '../../models/search';
import { Bienimmobilier } from '../../models/bienimmobilier';
import { HomeSearchComponent } from '../../layouts/home-search/home-search.component'
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'search-text-result',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './search-text-result.component.html',
  styleUrls: ['./search-text-result.component.css']
})
/*changeDetection: ChangeDetectionStrategy.OnPush, */
export class SearchTextResultComponent implements OnInit {
  public TopProprietes = [];
  public searchData: Search;
  public resultSearchT: Bienimmobilier[];
  public datafound: boolean = false;
  public mois; loading = true; error = '';
  msgresult = '';
  nbresult = 0;
  noResultImage = "assets/img/error/noresult.png"; // Image par défaut

  constructor(private searchRep: SearchService,
    @Inject(DOCUMENT) private _document: Document,
    private gData: AppglobalService,
    private router: Router,
    private _Activatedroute: ActivatedRoute,
    public translate: TranslateService) {
    this._Activatedroute.paramMap.subscribe(params => {
      this.ngOnInit();
    });
    // Initialize message with translation
    this.translate.get('SEARCH.NO_RESULTS').subscribe((res: string) => {
      this.msgresult = res;
    });
    // Écouter les changements de langue
    this.translate.onLangChange.subscribe((event) => {
      this.updateNoResultImage(event.lang);
    });

    // Initialiser l'image selon la langue actuelle
    this.updateNoResultImage(this.translate.currentLang);
    //this.toggleLoadingAnimation();
  }
  private updateNoResultImage(lang: string) {
    this.noResultImage = lang === 'fr' ?
      'assets/img/error/noresultfr.png' :
      'assets/img/error/noresult.png';
  }


  ngOnInit(): void {
    /*if(this.router.url === '/search'){
        this.reloadComponent()
      }*/
    let lien = window.location.href;
    localStorage.setItem("currentUrl", lien);
    this.SearchText();

  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }


  public SearchText() {
    this.loading = true;
    let t = localStorage.getItem("textData") || '';
    this.resultSearchT = [];
    this.error = "";
    this.searchRep
      .rechercheTextuelle(t)
      .subscribe(
        (response) => {                           //next() callback
          this.resultSearchT = response;
          document.body.scrollTop = 10; // For Safari
          document.documentElement.scrollTop = 10; // For Chrome, Firefox, IE and Opera  
          this.configMsg();
        },
        (error) => {                              //error() callback
          this.error = error;
          this.loading = false;
          // Afficher le message d'erreur traduit
          this.translate.get('SEARCH.NO_RESULTS').subscribe((res: string) => {
            this.msgresult = res;
          });
          this.nbresult = 0;
        },
        () => {                                   //complete() callback
          if (this.resultSearchT.length > 0) {
            this.datafound = true;
          } else {
            this.datafound = false;
            // S'assurer que le message est traduit même si aucun résultat
            this.translate.get('SEARCH.NO_RESULTS').subscribe((res: string) => {
              this.msgresult = res;
            });
            this.nbresult = 0;
          }
          this.loading = false;
        })
  }


  configMsg() {
    if (this.resultSearchT.length == 0) {
      this.translate.get('SEARCH.NO_RESULTS').subscribe((res: string) => {
        this.msgresult = res;
      });
      this.nbresult = 0;
    } else {
      this.translate.get('SEARCH.TOTAL_RESULTS', { count: this.resultSearchT.length }).subscribe((res: string) => {
        this.msgresult = res;
      });
      this.nbresult = this.resultSearchT.length;
    }
  }
}
